// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"286":"48f8d4b4","390":"48f8d4b4","658":"48f8d4b4","767":"48f8d4b4","888":"48f8d4b4","984":"48f8d4b4"}[chunkId] + ".chunk.css";
};